import $ from 'jquery';
import breakpoint from '../scripts/breakpoint';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-groupCompanySlider';
	$(base, context).each(function(i, el){
		var slider;

		function enableSlider() {
			slider = new Swiper (el.querySelector('.b-groupCompanySlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 16,
				slideClass: 'b-groupCompany',
			});
		}
	
		breakpoint('xs', 'lg')
			.onmatch(function(){
				return enableSlider();
			})
			.onmismatch(function(){
				if ( slider !== undefined ) slider.destroy( true, true );
					return;
			});
	});
});
